import { Link } from "react-router-dom";
import BrandLogo from "@/components/BrandLogo";

export default function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col" data-testid="auth-layout">
      <header className="px-6 lg:px-12 py-6">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-slate-900"
          data-testid="auth-brand-link"
        >
          <BrandLogo size="md" tone="light" testid="auth-brand-logo" />
          <span className="font-medium tracking-tight text-base">
            The AI Took My Job
          </span>
        </Link>
      </header>

      <main className="flex-1 flex items-center justify-center px-6 py-10">
        <div className="w-full max-w-md">
          <div className="bg-white border border-slate-200 rounded-3xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] p-8 lg:p-10">
            <h1 className="text-2xl lg:text-3xl font-medium text-slate-900 tracking-tight">
              {title}
            </h1>
            {subtitle ? (
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                {subtitle}
              </p>
            ) : null}
            <div className="mt-8">{children}</div>
          </div>
          {footer ? (
            <div className="mt-6 text-center text-sm text-slate-500">
              {footer}
            </div>
          ) : null}
        </div>
      </main>
    </div>
  );
}
